import { QueryClient } from '@tanstack/react-query';

import { userInfoKeys } from './user-info-keys';

import { Permission, permissionsKeys } from '../entities/permissions';
import type { UserInfo } from '../model';

export const getPrefetchedUserInfo = (queryClient: QueryClient) => {
  return queryClient.getQueryData<UserInfo>(userInfoKeys.all());
};

export const getPrefetchedPermissions = (queryClient: QueryClient) => {
  return queryClient.getQueryData<Permission[]>(permissionsKeys.all());
};
